'use client';

import { useFloating, useClick, useDismiss, useRole, useListNavigation, useTypeahead, useInteractions } from "../../../../external/@floating-ui/react/dist/floating-ui.react.js";
import { useState, useRef } from "react";
import { mergeRefs } from "../../../utils/props/mergeRefs.js";
import { autoUpdate } from "../../../../external/@floating-ui/dom/dist/floating-ui.dom.js";
import { offset, size, flip, shift } from "../../../../external/@floating-ui/react-dom/dist/floating-ui.react-dom.js";
const gapBeforeListDropdown = 4;
function useFloatingUi({
  isOpen,
  onOpenChange,
  onSelect,
  selectedIndex,
  optionsContent,
  triggerRef
}) {
  const [activeIndex, setActiveIndex] = useState(null);
  const listRef = useRef([]);
  const listContentRef = useRef(optionsContent || []);
  const isTypingRef = useRef(false);
  const { refs, floatingStyles, context } = useFloating({
    placement: "bottom-start",
    open: isOpen,
    onOpenChange,
    middleware: [
      offset(gapBeforeListDropdown),
      size({
        apply({ rects, elements }) {
          Object.assign(elements.floating.style, {
            minWidth: `${rects.reference.width}px`
          });
        }
      }),
      flip(),
      shift()
    ],
    transform: true,
    whileElementsMounted: autoUpdate
  });
  const click = useClick(context, { event: "mousedown" });
  const dismiss = useDismiss(context);
  const role = useRole(context, { role: "combobox" });
  const listNav = useListNavigation(context, {
    listRef,
    activeIndex,
    selectedIndex,
    onNavigate: setActiveIndex,
    loop: true
  });
  const typeahead = useTypeahead(context, {
    listRef: listContentRef,
    activeIndex,
    selectedIndex,
    onMatch: isOpen ? setActiveIndex : onSelect,
    onTypingChange(isTyping) {
      isTypingRef.current = isTyping;
    }
  });
  const { getReferenceProps, getFloatingProps, getItemProps } = useInteractions(
    [dismiss, role, listNav, typeahead, click]
  );
  const refElement = refs.domReference.current;
  return {
    labelProps: {
      onClick: () => refElement.focus()
    },
    dropdownProps: {
      ...getFloatingProps(),
      ref: refs.setFloating,
      style: floatingStyles
    },
    triggerProps: {
      ...getReferenceProps(),
      tabIndex: 0,
      ref: triggerRef ? mergeRefs(refs.setReference, triggerRef) : refs.setReference
    },
    listRef,
    isTypingRef,
    activeIndex,
    getItemProps,
    context
  };
}
export {
  useFloatingUi
};
